import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-system',
  templateUrl: './design-system.page.html',
  styleUrls: ['./design-system.page.scss']
})
export class DesignSystemPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
